import React, { useCallback } from 'react';
import MoodIcon from '@material-ui/icons/Mood';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import Grid from '@material-ui/core/Grid';
import ErrorIcon from '@material-ui/icons/Error';

import * as modalType from '../modal/modalTypes'
import * as warningType from '../flightDetail/warningTypes'
import * as flightType from '../flightDetail/flightInfoTypes'


//class BagMtow extends Component {
const BagMtow = (props) => {
  var moment = require('moment');

  //TODO set direction as constants

  // declare inbound bag amount, outbound bag amount and mtow number            
  let { onShowModal, flightDetail, allSSR } = props
  let depEdctDiffTime = props.depEdctDiffTime;
  //console.info("nvhshbd",depEdctDiffTime);

  //declare mtow display class: red or green
  const onClick = useCallback(e => onShowModal(modalType.MTOW, flightDetail));
  const onClickWeightAlert = useCallback(e => onShowModal(modalType.WEIGHT_ALERT, selectedComponentFlightDetail));
  
  //Default inbound and outbound ssr for use
  let { inboundSSR, outboundSSR, checkedBags } = 'N/A'

  let terminatorFlight = flightDetail.TerminatorFlight > 0

  //Separate inbound and outbound SSR by direction.
  if (allSSR != null) {
    inboundSSR = allSSR.filter(          //Note: 1 for inbound, BAG is one of the SSR codes
      pax =>
        pax.Direction == 1
    )
    outboundSSR = allSSR.filter(         //Note: 2 for inbound, BAG is one of the SSR codes
      pax =>
        pax.Direction == 2
    )
  }

  if (flightDetail.PassengerDetails != null) {    
    checkedBags = flightDetail.PassengerDetails.filter(
      pax =>
        pax.CheckedInBags > 0
    )
  }

  function bagDetails(direction) {
    let totalBag = 0                              //Default total bag number to 0
    if (checkedBags && checkedBags.length) {
      checkedBags.map(pax => {                 //Parse all SSR per passenger, 'pax' may contain multiple SSR
        if (pax.Direction == direction)
          totalBag += pax.CheckedInBags 
      })
      return  totalBag == 1 ? totalBag + ' bag' : totalBag + ' bags' //Return total bag amount
    } else {
      return '0 bags'                                  //Otherwise function returns value 0
    }
  }

  function finalTow(mtow, tow) {
    let finalTow = flightDetail.MTOWOutbound - flightDetail.TOWOutbound
    let status = ''
    let mood = ''
    let warning = ''
    
    if (finalTow < 0) {
      finalTow = Math.abs(finalTow)
      status = 'lb over'
      mood = <ErrorIcon />
      warning = 'warning'
    } else {
      status = 'lb available'
      mood = <MoodIcon />
    }
    
    return (
      <span className={warning}>{mood} <a href="javascript:;" onClick={onClick}>{finalTow} {status}</a></span>
    )
  }

  let selectedComponentFlightDetail = {           //Build new directional modal
    direction: '',
    fltNum: '',
    tailNum: '',
    depCity: '',
    arrCity: '',
    time: '',
    warnings: []
  }
  
  //Component weight alert
  function weightAlert(direction) {
    let hasSSR = 0
    
    if (direction == 1) {
      hasSSR = inboundSSR
    } else {
      hasSSR = outboundSSR
    }

    let displayWeightAlert = false
    let thisDirection = 0    
    if (flightDetail.Warnings) {      
      let hasComponentWeightAlert = flightDetail.Warnings.filter(warning => warning.Type == warningType.COMPONENT_WEIGHT && warning.Direction ==  (terminatorFlight ? 1 : direction))
      if (hasComponentWeightAlert.length > 0) {
        
         hasComponentWeightAlert.map(warning => {                   //toggle directional Component weight alert
          selectedComponentFlightDetail.warnings.push(warning)
          if (warning.Direction == 1) {//only show warning for inbound
            displayWeightAlert = true
            thisDirection = warning.Direction
          }
        })

        if (terminatorFlight) {
          selectedComponentFlightDetail.direction = 'INBOUND'
          selectedComponentFlightDetail.fltNum = flightDetail.FltNumOutbound
          selectedComponentFlightDetail.tailNum = flightDetail.UncorrectedTailNum
          selectedComponentFlightDetail.depCity = flightDetail.DepAirportOutbound
          selectedComponentFlightDetail.arrCity = 'YTZ'
          selectedComponentFlightDetail.time = flightDetail.ETA_Outbound
        }
        else if (thisDirection == direction && direction == 1) {
          selectedComponentFlightDetail.direction = 'INBOUND'
          selectedComponentFlightDetail.fltNum = flightDetail.FltNumInbound
          selectedComponentFlightDetail.tailNum = flightDetail.UncorrectedTailNumInbound
          selectedComponentFlightDetail.depCity = flightDetail.DepAirportInbound
          selectedComponentFlightDetail.arrCity = 'YTZ'
          selectedComponentFlightDetail.time = flightDetail.ETA_Inbound
        } else if (thisDirection == direction && direction == 2) {
          selectedComponentFlightDetail.direction = 'OUTBOUND'
          selectedComponentFlightDetail.fltNum = flightDetail.FltNumOutbound
          selectedComponentFlightDetail.tailNum = flightDetail.UncorrectedTailNum
          selectedComponentFlightDetail.depCity = 'YTZ'
          selectedComponentFlightDetail.arrCity = flightDetail.ArrAirportOutbound
          selectedComponentFlightDetail.time = flightDetail.EDCT == null ? flightDetail.ETD : moment(flightDetail.EDCT).subtract(depEdctDiffTime, 'minutes').format('HH:mm')
        }
        if (displayWeightAlert) {
          return (
            <span className="warning"><ErrorIcon /> <a href="javascript:;" onClick={onClickWeightAlert}>{bagDetails(direction)}</a><br /></span>)
        } else {
          return (<span><LocalMallIcon /> {bagDetails(direction)}<br /></span>)
        }
      }
    }
    return (<span><LocalMallIcon /> {bagDetails(direction)}<br /></span>)
  }


  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        {!terminatorFlight ? weightAlert(1) : weightAlert(2)}                
      </Grid>
      <Grid item xs={6}>
        {!terminatorFlight ? weightAlert(2) : ''}
        {!terminatorFlight ? finalTow(flightDetail.MTOWOutbound, flightDetail.TOWOutbound) : ''}
      </Grid>
    </Grid>
  );
}

export default BagMtow